var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DropdownButton',{attrs:{"iconButton":"","skipTooltip":_vm.skipTooltip,"text":_vm.buttonText,"disabled":_vm.disabled,"icon":_vm.icon,"items":_vm.items},on:{"click":function($event){return _vm.goToPlant($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }